module.exports = __webpack_public_path__ + "static/media/instagram-icon.c400e9d9.svg";